export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8912.ccaf4468.jpg";